// extracted by mini-css-extract-plugin
export default {"title":"Users_title__v-WrV"};